export default __webpack_public_path__ + "static/2-category-e8882f7ac657481df1f19b17f6816efb.jpg";